import { ca } from '@cian/analytics';

export function trackShowPhoneInLayoutsClick(gaLabel: string) {
  ca('eventSite', {
    action: 'Open_layout_modal_block',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    useLastProducts: true,
  });
}
